export const noti = {
    text1: "Notifications",
    text2: "Liste des notifications.",
    text3: "Vous n'avez aucune notification",
};